import { Component } from '@angular/core';
import {MatListModule} from '@angular/material/list';
import { MemberDetailFormComponent } from './member-detail-form/member-detail-form.component';
import { NgIf } from '@angular/common';
import { PersonalityComponent } from './personality/personality.component';
import { LifeStyleComponent } from './life-style/life-style.component';
import { HealthComponent } from './health/health.component';
import { DietaryComponent } from './dietary/dietary.component';
import { FitnessComponent } from './fitness/fitness.component';
import { ActivatedRoute } from '@angular/router';
// import { AllFoodLogsComponent } from "./all-food-logs/all-food-logs.component";
import { MedicationComponent } from './medication/medication.component';
import { DietaryDetailsComponent } from './dietary-details/dietary-details.component';
import { DietaryPreferenceComponent } from './dietary-preference/dietary-preference.component';
import { LifestyleConditionComponent } from './lifestyle-condition/lifestyle-condition.component';
import { NgClass } from '@angular/common';
import { Router,RouterLink } from "@angular/router";
import { ProgressNotesComponent } from './progress-notes/progress-notes.component';
import { MemberMedicationComponent } from './member-medication/member-medication.component';
import { MeetingNotesComponent } from './meeting-notes/meeting-notes.component';
import { MealPlanHistoryComponent } from './mealplan-history/mealplan-history.component';
import { MemberService } from './member-service/MemberService ';
import { formatDate } from '@angular/common';
import { MemberDashboardService } from '../member-dashboard/member-dashboard.service';
// import { SleepGraphComponent } from './activity-graph/sleep-graph.component';
// import { ActivityGraphComponent } from './sleep-graph/activity-graph.component';
import { BloodReportAnalysesComponent } from './blood-report-analyses/blood-report-analyses.component';
import { BiweeklyReportHistoryComponent } from './biweekly-report-history/biweekly-report-history.component';
import { GoalComponent } from './goal/goal.component'; 
import { MdhHealthToolsComponent } from './health-tools/md-health-tools.component';
import { ReminderComponent } from './reminder/reminder.component';
import { WishesComponent } from './wishes/wishes.component';
import { LogHba1cComponent } from './log-hba1c/log-hba1c.component';

@Component({
  selector: 'app-member-details',
  standalone: true,
  imports: [NgClass, LifestyleConditionComponent, MatListModule,
    DietaryPreferenceComponent, DietaryDetailsComponent, MedicationComponent,
    MemberDetailFormComponent, NgIf, PersonalityComponent, LifeStyleComponent,
    HealthComponent, DietaryComponent, FitnessComponent, 
    // AllFoodLogsComponent,
    ProgressNotesComponent, MeetingNotesComponent, MealPlanHistoryComponent, 
    // SleepGraphComponent, 
    // ActivityGraphComponent, 
    RouterLink, MemberMedicationComponent, BloodReportAnalysesComponent, BiweeklyReportHistoryComponent, GoalComponent, MdhHealthToolsComponent, ReminderComponent, WishesComponent, LogHba1cComponent],
  templateUrl: './member-details.component.html',
  styleUrl: './member-details.component.css'
})
export class MemberDetailsComponent {
  isSubMenu:any=0;
  subMenu:any=0;
  isMemberDairy:boolean=true;
  isLifeStyle:boolean=false;
  isPersonality:boolean=false;
  isHealth:boolean=false;
  isDietary:boolean=false;
  isfitness:boolean=false;
  mainTab: any ='Dairy';
  subTab:any='';
  health: any = [];
  memberName: string = '';
  memberDetail: any;
  stateObj:any;
  memberId: string = '';
  goalSummaryDate: Date = new Date();
  goalSummary = {
    plan: 'No Plan Found',
    age: '---',
    gender: '---',
    dob: '---',
    height: '---',
    weight: '---',
    weightTimestamp: '',
    levelOfCare: '---',
    bmi: '---',
    bmiTimestamp: '',
    lastHbA1c: '---'
  };
  constructor(
    private memberService: MemberService,
    private route: ActivatedRoute,
    private router: Router,
    private memberDashboardService: MemberDashboardService
  ){

  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      var memberId = this.route.snapshot.queryParamMap.get('id') || '';
      this.memberId = memberId;
      if (memberId) {
        this.getMemberById(memberId);
      }
    });
    var tabtype = this.route.snapshot.queryParamMap.get('islist') || "";
    if (tabtype=="5") {
      this.selectedTab(5, 7, "Monitor","food");
    }  
     const { stateObj } = window.history.state; 
     this.stateObj = stateObj;
    //this.question.getQuestion(this.route.snapshot.queryParamMap.get('id')).subscribe(response => { 
    //  //console.log(response);
      
    //  this.health = response.items.filter((questions:any) => questions.questionCategory === "HealthAndMedication");
    //  console.log(this.health);
    //});
    
  }
  getMemberById(id: string) {
    this.memberService.getMemberById(id).subscribe(data => {
      if (data) {        
        this.memberDetail = data.result;
        this.memberName = `${data.result.firstName} ${data.result.lastName}`;
        this.updateGoalSummaryBaseInfo();
      }
    });
  }

  selectedTab(type:any,subMenu:any,tab:any,flow?:any){
    this.mainTab = tab;
    this.isSubMenu = type;
    this.subMenu=subMenu;
    if(type== 2){
      this.subTab = 'Medication';
    }else  if(type== 5){
      // this.subTab = 'activitygraph';
      this.subTab = 'Meal'; // Set to Meal Plan History as default
      this.subMenu = 9; // Set to Meal Plan History sub-tab
    }else if(type== 3){
      this.subTab = 'bloodreport';
      this.subMenu = 12; // Set to Blood Report Analyses History sub-tab
    }
    if(tab === 'Goals') {
      this.goalSummaryDate = new Date();
      this.loadGoalSummaryData(this.goalSummaryDate);
    }
    if(flow == "food"){
      // this.subTab = 'Food';
      this.subTab = 'Meal'; // Redirect to Meal Plan History instead
      this.subMenu = 9;
    }
     if(type==1){
      this.isMemberDairy = true;
     }else{
      this.isMemberDairy = false;
    }
   
  }

  subSelectedTab(type:any,tab:any){
   this.diablesubSelected();
   this.subMenu=type;
   this.subTab =tab;
    // if(type == 1){
    //   this.isPersonality=true;
    // }
    // else if(type == 2){
    //   this.isLifeStyle=true;
    // }
    // else if(type == 3){
    //   this.isHealth=true;
    // }
    // else if(type == 4){
    //   this.isDietary=true;
    // }
    // else if(type == 5){
    //   this.isfitness=true;
    // }
  }

  diablesubSelected(){
    // this.isPersonality=false;
    // this.isLifeStyle=false;
    // this.isHealth=false;
    // this.isDietary=false;
    // this.isfitness=false;
    this.subMenu=0;
  }

backBtn(){
  this.router.navigate(['/members'],{state:{stateObj:this.stateObj}});
  }

navigateToMemberDashboard(){
  this.router.navigate(['/member-dashboard'], { queryParams: { memberId: this.memberId } });
}
  
  private updateGoalSummaryBaseInfo(): void {
    const detail = this.memberDetail || {};
    this.goalSummary.plan = detail.plan ? detail.plan : 'No Plan Found';
    this.goalSummary.age = detail.age != null ? String(detail.age) : '---';
    this.goalSummary.gender = detail.gender ?? '---';
    this.goalSummary.dob = detail.dateOfBirth ? this.safeFormatDate(detail.dateOfBirth) : '---';
    const heightValue = detail.height != null ? Number(detail.height).toFixed(2) : null;
    const heightUnit = detail.heightUnit ? ` ${detail.heightUnit}` : '';
    this.goalSummary.height = heightValue ? `${heightValue}${heightUnit}` : '---';
    const level = (detail.memberLevel ?? '').toString().trim();
    this.goalSummary.levelOfCare = level ? level : '---';
    this.goalSummary.lastHbA1c = detail.lastHbA1c != null ? String(detail.lastHbA1c) : '---';
  }

  private safeFormatDate(value: string): string {
    try {
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return value;
      }
      // Format only the date part so the timezone can't shift the day
      return formatDate(value.split('T')[0], 'MMMM dd, y', 'en-US');
    } catch {
      return value;
    }
  }

  private loadGoalSummaryData(date: Date): void {
    if (!this.memberId) {
      return;
    }
    const formattedDate = formatDate(date, 'Y-MM-d', 'en');
    this.memberDashboardService.getVital(this.memberId, formattedDate).subscribe(response => {
      const normalized: any = (response as any)?.result ?? response;
      const bmiData = normalized?.bmiData;
      if (bmiData && bmiData.weight_lb != null) {
        this.goalSummary.weight = `${bmiData.weight_lb} lb`;
        this.goalSummary.weightTimestamp = this.getGoalDisplayLabel(bmiData);
      } else {
        this.goalSummary.weight = '---';
        this.goalSummary.weightTimestamp = '';
      }

      if (bmiData && bmiData.bmi != null) {
        this.goalSummary.bmi = String(bmiData.bmi);
        this.goalSummary.bmiTimestamp = this.getGoalDisplayLabel(bmiData);
      } else {
        this.goalSummary.bmi = '---';
        this.goalSummary.bmiTimestamp = '';
      }
    });
  }

  private shouldShowGoalLabel(bmiData: any): boolean {
    return bmiData && bmiData.isMostRecentPreviousReading === true;
  }

  private getGoalDisplayLabel(bmiData: any): string {
    if (this.shouldShowGoalLabel(bmiData) && bmiData?.timestamp) {
      return `(As of ${this.formatGoalTimestamp(bmiData.timestamp)})`;
    }
    return '';
  }

  private formatGoalTimestamp(timestamp: string): string {
    if (!timestamp) {
      return '';
    }
    try {
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) {
        return timestamp;
      }
      return formatDate(date, 'MMM d h:mm a', 'en-US');
    } catch {
      return timestamp;
    }
  }

}
